import { render, staticRenderFns } from "./RecoverPasswordForm.vue?vue&type=template&id=0a384948&scoped=true&"
import script from "./RecoverPasswordForm.vue?vue&type=script&lang=js&"
export * from "./RecoverPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./RecoverPasswordForm.vue?vue&type=style&index=0&id=0a384948&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a384948",
  null
  
)

component.options.__file = "RecoverPasswordForm.vue"
export default component.exports